(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kaolenne-mobile-carousel')) {
    customElements.define('kaolenne-mobile-carousel', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (!this.isConnected || this.events) return;
        this.events = new AbortController();
        this.mobile = matchMedia('(max-width: 749px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.userPaused = false;
        this.inView = true;
        const options = { signal: this.events.signal };
        const updateMode = () => this.mobile.matches ? this.enable() : this.disable();
        this.mobile.addEventListener('change', updateMode, options);
        this.reducedMotion.addEventListener('change', () => this.schedule(), options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') this.hovered = true;
          this.schedule();
        }, options);
        this.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.schedule();
        }, options);
        this.addEventListener('pointerdown', () => {
          this.pressed = true;
          this.schedule();
        }, options);
        const release = () => { this.pressed = false; this.schedule(); };
        window.addEventListener('pointerup', release, options);
        window.addEventListener('pointercancel', release, options);
        this.addEventListener('focusin', () => this.schedule(), options);
        this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
        this.addEventListener('click', event => this.onClick(event), options);
        this.addEventListener('keydown', event => this.onKeydown(event), options);
        this.addEventListener('shopify:block:select', event => {
          if (!this.track) return;
          const index = this.items.findIndex(item => item.element === event.target || item.element.contains(event.target));
          if (index !== -1) this.goTo(index, false);
        }, options);
        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting;
            this.schedule();
          });
          this.visibilityObserver.observe(this);
        }
        updateMode();
      }

      enable() {
        if (this.track) return;
        const groups = Array.from(this.children).filter(child => child.classList.contains('group-block'));
        if (groups.length < 2) return;
        this.originalRole = this.getAttribute('role');
        this.originalDescription = this.getAttribute('aria-roledescription');
        this.originalLabel = this.getAttribute('aria-label');
        this.originalTabindex = this.getAttribute('tabindex');
        this.setAttribute('role', 'region');
        this.setAttribute('aria-roledescription', 'carousel');
        if (!this.originalLabel) this.setAttribute('aria-label', 'Store services');
        this.setAttribute('tabindex', '0');
        this.classList.add('is-mobile-carousel');
        this.track = document.createElement('div');
        this.track.className = 'kaolenne-mobile-carousel__track';
        groups[0].before(this.track);
        this.items = groups.map((element, index) => {
          const marker = document.createComment('kaolenne-carousel-position');
          element.before(marker);
          const attributes = {};
          for (const name of ['id', 'role', 'aria-roledescription', 'aria-label', 'aria-hidden', 'inert']) {
            attributes[name] = element.getAttribute(name);
          }
          if (!element.id) element.id = `KaolenneSlide-${this.dataset.sectionId}-${index + 1}`;
          element.setAttribute('role', 'group');
          element.setAttribute('aria-roledescription', 'slide');
          element.setAttribute('aria-label', `${index + 1} of ${groups.length}`);
          this.track.append(element);
          return { element, marker, attributes };
        });
        this.controls = document.createElement('div');
        this.controls.className = 'kaolenne-mobile-carousel__controls';
        const dots = document.createElement('div');
        dots.className = 'kaolenne-mobile-carousel__dots';
        dots.setAttribute('role', 'group');
        dots.setAttribute('aria-label', 'Slide navigation');
        this.dots = this.items.map((item, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'kaolenne-mobile-carousel__dot';
          button.dataset.slide = index;
          button.setAttribute('aria-label', `Go to slide ${index + 1} of ${groups.length}`);
          button.setAttribute('aria-controls', item.element.id);
          dots.append(button);
          return button;
        });
        this.controls.append(dots);
        if (this.dataset.autoplay === 'true') {
          this.pauseButton = document.createElement('button');
          this.pauseButton.type = 'button';
          this.pauseButton.className = 'kaolenne-mobile-carousel__pause';
          this.pauseButton.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><g data-pause><rect x="4" y="3" width="3" height="10"/><rect x="9" y="3" width="3" height="10"/></g><path data-play d="M5 2.5L13 8L5 13.5Z"/></svg>';
          this.controls.append(this.pauseButton);
          this.updatePauseButton();
        }
        this.status = document.createElement('span');
        this.status.className = 'kaolenne-mobile-carousel__status';
        this.status.setAttribute('aria-atomic', 'true');
        this.controls.append(this.status);
        this.append(this.controls);
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.timer);
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => {
            if (!this.track) return;
            const rtl = getComputedStyle(this.track).direction === 'rtl';
            const edge = rtl ? 'right' : 'left';
            const start = this.track.getBoundingClientRect()[edge];
            let nearest = 0;
            let distance = Infinity;
            this.items.forEach((item, index) => {
              const current = Math.abs(item.element.getBoundingClientRect()[edge] - start);
              if (current < distance) { distance = current; nearest = index; }
            });
            this.update(nearest);
            this.schedule();
          });
        }, { passive: true });
        this.resizeObserver = new ResizeObserver(() => {
          if (this.track) this.goTo(this.index, false);
        });
        this.resizeObserver.observe(this.track);
        this.goTo(Math.min(this.index, this.items.length - 1), false);
      }

      update(index) {
        this.index = index;
        this.items.forEach((item, current) => {
          const active = current === index;
          item.element.setAttribute('aria-hidden', String(!active));
          if (!window.Shopify?.designMode) item.element.inert = !active;
          this.dots[current].setAttribute('aria-current', String(active));
        });
        this.status.textContent = `Slide ${index + 1} of ${this.items.length}`;
      }

      goTo(index, animate = true) {
        if (!this.track) return;
        index = (index + this.items.length) % this.items.length;
        const edge = getComputedStyle(this.track).direction === 'rtl' ? 'right' : 'left';
        const delta = this.items[index].element.getBoundingClientRect()[edge] - this.track.getBoundingClientRect()[edge];
        this.track.scrollTo({
          left: this.track.scrollLeft + delta,
          behavior: animate && !this.reducedMotion.matches ? 'smooth' : 'instant'
        });
        this.update(index);
        this.schedule();
      }

      onClick(event) {
        if (!this.track || !(event.target instanceof Element)) return;
        const dot = event.target.closest('.kaolenne-mobile-carousel__dot');
        if (dot && this.controls.contains(dot)) this.goTo(Number(dot.dataset.slide));
        if (this.pauseButton?.contains(event.target)) {
          this.userPaused = !this.userPaused;
          this.updatePauseButton();
          this.schedule();
        }
      }

      onKeydown(event) {
        if (!this.track || event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        let index;
        if (event.key === 'ArrowRight') index = this.index + (rtl ? -1 : 1);
        if (event.key === 'ArrowLeft') index = this.index + (rtl ? 1 : -1);
        if (event.key === 'Home') index = 0;
        if (event.key === 'End') index = this.items.length - 1;
        if (index === undefined) return;
        event.preventDefault();
        this.goTo(index);
        if (event.target.closest('.kaolenne-mobile-carousel__dot')) this.dots[this.index].focus({ preventScroll: true });
      }

      updatePauseButton() {
        const label = this.userPaused ? 'Resume automatic slide changes' : 'Pause automatic slide changes';
        this.pauseButton.dataset.paused = String(this.userPaused);
        this.pauseButton.setAttribute('aria-label', label);
        this.pauseButton.title = label;
      }

      schedule() {
        clearTimeout(this.timer);
        if (this.status) {
          this.status.setAttribute('aria-live', this.dataset.autoplay === 'true' && !this.userPaused ? 'off' : 'polite');
        }
        if (!this.track || this.dataset.autoplay !== 'true' || this.userPaused || this.hovered || this.pressed ||
            this.contains(document.activeElement) || document.hidden || !this.inView ||
            this.reducedMotion.matches || window.Shopify?.designMode) return;
        const interval = Math.max(3000, Number(this.dataset.interval) || 5000);
        this.timer = setTimeout(() => this.goTo(this.index + 1), interval);
      }

      disable() {
        clearTimeout(this.timer);
        cancelAnimationFrame(this.scrollFrame);
        this.resizeObserver?.disconnect();
        if (!this.track) return;
        this.items.forEach(({ element, marker, attributes }) => {
          for (const [name, value] of Object.entries(attributes)) {
            if (value === null) element.removeAttribute(name);
            else element.setAttribute(name, value);
          }
          marker.replaceWith(element);
        });
        this.track.remove();
        this.controls.remove();
        this.track = null;
        this.controls = null;
        this.pauseButton = null;
        this.status = null;
        this.items = [];
        this.dots = [];
        this.classList.remove('is-mobile-carousel');
        if (this.originalRole === null) this.removeAttribute('role');
        else this.setAttribute('role', this.originalRole);
        if (this.originalDescription === null) this.removeAttribute('aria-roledescription');
        else this.setAttribute('aria-roledescription', this.originalDescription);
        if (this.originalLabel === null) this.removeAttribute('aria-label');
        else this.setAttribute('aria-label', this.originalLabel);
        if (this.originalTabindex === null) this.removeAttribute('tabindex');
        else this.setAttribute('tabindex', this.originalTabindex);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.events?.abort();
        this.visibilityObserver?.disconnect();
        this.disable();
        this.events = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
